<template>
  <b-container v-if="!isSubTestView" class="bv-example-row" fluid>
    <b-row align-h="between">
      <b-col cols="auto">
        <h3>รายการตรวจของ {{ testTypeName }}</h3>
      </b-col>
      <b-col cols="auto">
        <b-button variant="success" @click="openFieldModal(null)"
          >เพิ่มรายการตรวจ</b-button
        >
      </b-col>
    </b-row>
    <b-row align-h="start">
      <b-col cols="auto">
        <b-button @click="backHandler">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="tests"
      >
        <template slot="id" slot-scope="data">
          <div class="col-right">{{ data.item.id }}</div>
        </template>
        <template slot="unit" slot-scope="data">
          <div class="col-left">{{ data.item.unit ? data.item.unit : "" }}</div>
        </template>
        <template slot="price" slot-scope="data">
          <div class="col-right">{{ data.item.price }}</div>
        </template>
        <template slot="abbreviation" slot-scope="data">
          <div class="col-left">{{ data.item.abbreviation }}</div>
        </template>
        <template slot="sequence" slot-scope="data">
          <div class="col-right">
            <b-row>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-up']"
                  :class="{
                    icon: true,
                    disable: checkMinMax(
                      data.item.sequence,
                      tests,
                      'sequence',
                      'min'
                    ),
                  }"
                  @click="changePositionHandler(data.item.id, 'up')"
                />
              </b-col>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-down']"
                  :class="{
                    icon: true,
                    disable: checkMinMax(
                      data.item.sequence,
                      tests,
                      'sequence',
                      'max'
                    ),
                  }"
                  @click="changePositionHandler(data.item.id, 'down')"
                />
              </b-col>
              <b-col cols="auto">{{ data.item.sequence }}</b-col>
            </b-row>
          </div>
        </template>
        <template slot="min_ref_ranges" slot-scope="data">
          <div class="col-right">{{ data.item.min_ref_ranges }}</div>
        </template>
        <template slot="max_ref_ranges" slot-scope="data">
          <div class="col-right">{{ data.item.max_ref_ranges }}</div>
        </template>
        <template slot="created_at" slot-scope="data">
          <div class="col-center">{{ data.item.created_at }}</div>
        </template>
        <template slot="unit" slot-scope="data">
          <div class="col-left">{{ data.item.unit }}</div>
        </template>

        <template slot="machine_id" slot-scope="data">
          <div class="col-left">
            {{ data.item.machine ? data.item.machine.name : "" }}
          </div>
        </template>

        <!--                <template slot="test_type_id" slot-scope="data">-->
        <!--                    <div class="col-left">-->
        <!--                        {{data.item.test__type ? data.item.test__type.name : ''}}-->
        <!--                    </div>-->
        <!--                </template>-->

        <template slot="action" slot-scope="data">
          <b-container fluid>
            <b-row align-h="center">
              <b-col cols="auto">
                <!--                <fa-icon-->
                <!--                    :icon="['fas', 'arrow-right']"-->
                <!--                    class="icon"-->
                <!--                    @click="openSubTestHandler(data.item.id)"-->
                <!--                    v-if="data.item.has_sub_tests"-->
                <!--                    :id="`sub-test-route-${data.item.id}`"-->
                <!--                />-->
                <b-button
                  v-if="data.item.has_sub_tests"
                  :id="`sub-test-route-${data.item.id}`"
                  class="button btn-dark"
                  @click="openSubTestHandler(data.item.id)"
                  >ดูรายละเอียด</b-button
                >
                <b-popover
                  :target="`sub-test-route-${data.item.id}`"
                  triggers="hover"
                  placement="top"
                  >ไปยังผลตรวจย่อย</b-popover
                >
              </b-col>
              <!--                            <b-col cols="auto">-->
              <!--                                <fa-icon-->
              <!--                                    :icon="['fas', 'vial']"-->
              <!--                                    class="icon"-->
              <!--                                    @click="openSpecimenTypeHandler(data.item.id)"-->
              <!--                                    :id="`specimen-type-test-route-${data.item.id}`"-->
              <!--                                />-->
              <!--                                <b-popover :target="`specimen-type-test-route-${data.item.id}`" triggers="hover" placement="top">-->
              <!--                                    แก้ไขตัวอย่างผลตรวจ (Specimen Type)-->
              <!--                                </b-popover>-->
              <!--                            </b-col>-->
              <b-col cols="auto">
                <!--                <fa-icon-->
                <!--                    :icon="['fas', 'edit']"-->
                <!--                    class="icon warning"-->
                <!--                    @click="openFieldModal(data.item.id)"-->
                <!--                    :id="`edit-test-route-${data.item.id}`"-->
                <!--                />-->
                <b-button
                  :id="`edit-test-route-${data.item.id}`"
                  class="button btn-warning"
                  @click="openFieldModal(data.item.id)"
                  >แก้ไข</b-button
                >
                <b-popover
                  :target="`edit-test-route-${data.item.id}`"
                  triggers="hover"
                  placement="top"
                  >แก้ไขผลตรวจ</b-popover
                >
                <!--                                <b-button variant="warning" @click="openFieldModal(data.item.id)">-->
                <!--                                    แก้ไข-->
                <!--                                </b-button>-->
              </b-col>
              <b-col cols="auto">
                <!--                <fa-icon-->
                <!--                    :icon="['fas', 'trash']"-->
                <!--                    class="icon danger"-->
                <!--                    @click="openDeleteModal(data.item.id)"-->
                <!--                    :id="`delete-test-route-${data.item.id}`"-->
                <!--                />-->
                <b-button
                  :id="`delete-test-route-${data.item.id}`"
                  class="button btn-danger"
                  @click="openDeleteModal(data.item.id)"
                  >ลบ</b-button
                >
                <b-popover
                  :target="`delete-test-route-${data.item.id}`"
                  triggers="hover"
                  placement="top"
                  >ลบผลตรวจ</b-popover
                >
                <!--                                <b-button variant="danger" @click="openDeleteModal(data.item.id)">-->
                <!--                                    ลบ-->
                <!--                                </b-button>-->
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
      <div v-if="tests.length === 0" class="row" style="margin:auto">
        <span>ไม่มีข้อมูล</span>
      </div>
    </b-row>
    <b-modal
      ref="inputModal"
      :title="modalTitle"
      size="xl"
      :no-enforce-focus="true"
      @ok="submit"
      @cancel="resetTestInput"
      @close="resetTestInput"
      @shown="clearInputField"
    >
      <test-input-modal
        :options.sync="options"
        :test-input.sync="testInput"
        test-level="test"
      />
    </b-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delTest"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
  <sub-test
    v-else
    :sub-tests.sync="subTests"
    :back-handler="subBackHandler"
    :test-id.sync="testSelected"
    :test-name.sync="testSelectedName"
    :test-type-id="testTypeId"
    :test-type-name="testTypeName"
  />
</template>

<script>
import { mapActions } from "vuex";
import InputModal from "../../components/Settings/InputModal";
import ConfirmModal from "../../components/Settings/ConfirmModal";
import TestInputModal from "../../components/Settings/TestInputModal";
import SubTest from "../../views/Settings/SubTest";
import Swal from "sweetalert2";

export default {
  name: "Test",
  components: {
    // InputModal,
    ConfirmModal,
    TestInputModal,
    SubTest,
  },
  props: {
    tests: {
      type: Array,
    },
    backHandler: {
      type: Function,
    },
    testTypeName: {
      type: String,
    },
    testTypeId: {
      type: Number,
    },
  },
  data() {
    return {
      testSelected: null,
      subTests: [],
      testSelectedName: "",
      isSubTestView: false,
      fields: [
        // {
        //   key: 'id',
        //   label: 'ID',
        //   isInputField: false,
        // },
        //   {
        //       key: 'test_type_id',
        //       label: 'TEST TYPE',
        //       isInputField: true,
        //       isSpecialField: true,
        //       fieldType: 'selected',
        //       resources: []
        //   },
        {
          key: "sequence",
          label: "NO",
          isInputField: true,
          isSpecialField: true,
          fieldType: "number",
        },
        {
          key: "name",
          label: "NAME",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },

        {
          key: "machine_id",
          label: "MACHINE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "selected",
          resources: [],
        },
        {
          key: "price",
          label: "PRICE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "number",
        },
        {
          key: "unit.name",
          label: "UNIT",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        {
          key: "abbreviation",
          label: "ABBREVIATION",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        // {
        //   key: 'min_ref_ranges',
        //   label: 'MIN REF RANGES',
        //   isInputField: true,
        //   isSpecialField: true,
        //   fieldType: 'number'
        // },
        // {
        //   key: 'max_ref_ranges',
        //   label: 'MAX REF RANGES',
        //   isInputField: true,
        //   isSpecialField: true,
        //   fieldType: 'number'
        // },
        // {
        //   key: 'created_at',
        //   label: 'DATE CREATED',
        //   isInputField: false,
        // },
        {
          key: "action",
          label: "ACTIONS",
          isInputField: false,
        },
      ],
      inputFields: [
        {
          key: "name",
          label: "Name",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        // {
        //   key: 'test_type_id',
        //   label: 'Test Type',
        //   fieldType: 'selected',
        //   resources: [],
        //   textField: 'name',
        //   valueField: 'id',
        //   value: '',
        //   required: true,
        //   default: ''
        // },
        {
          key: "machine_id",
          label: "Machine",
          fieldType: "selected",
          resources: [],
          textField: "name",
          valueField: "id",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "price",
          label: "PRICE",
          value: "",
          required: true,
          default: "",
          fieldType: "number",
        },
        {
          key: "unit",
          label: "UNIT",
          value: "",
          required: true,
          default: "",
          fieldType: "text",
        },
        {
          key: "abbreviation",
          label: "ABBREVIATION",
          value: "",
          required: true,
          default: "",
          fieldType: "text",
        },
        {
          key: "sequence",
          label: "SEQUENCE",
          value: "",
          required: true,
          default: "",
          fieldType: "number",
        },
        {
          key: "min_ref_ranges",
          label: "MIN REF RANGES",
          value: "",
          required: true,
          default: "",
          fieldType: "number",
        },
        {
          key: "max_ref_ranges",
          label: "MAX REF RANGES",
          value: "",
          required: true,
          default: "",
          fieldType: "number",
        },
        {
          key: "priceCanine",
          label: "CANINE/FELINE PRICE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        {
          key: "priceMammal",
          label: "EXOTIC MAMMAL PRICE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        {
          key: "priceLiveStock",
          label: "LIVESTOCK PRICE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
      ],
      items: [],
      itemSelected: null,
      modalTitle: "",
      deleteSpeciesIdSelected: null,
      testInput: {
        test_type_id: this.testTypeId,
        for_specie_id: null,
        is_specify_detail: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        name: null,
        has_sub_tests: false,
        input_type: null,
        separate_from_test_type: null,
        separate_from_remark: null,
        remark: null,
        display_ref_alert: null,
        display_abbreviation: false,
        specimen_type: [],
      },
      options: [],
    };
  },
  methods: {
    ...mapActions({
      getTests: "Settings/getTestList",
      getSubTestListByTestId: "Settings/getSubTestListByTestId",
      getMachine: "Test/getMachine",
      getTestType: "Settings/getTestTypeList",
      createTest: "Settings/createTest",
      updateTest: "Settings/updateTest",
      deleteTest: "Settings/deleteTest",
      updateSequenceTest: "Settings/updateSequenceTest",
      getTestByTestTypeId: "Settings/getTestByTestTypeId",
    }),
    async openFieldModal(testId = null) {
      const testSelected = testId
        ? this.tests.find((test) => test.id === testId)
        : null;
      if (testSelected) {
        this.testInput = {
          id: testSelected.id,
          test_type_id: this.testTypeId,
          for_specie_id: testSelected.for_specie_id,
          is_specify_detail: null,
          price: testSelected.price,
          machine_id: testSelected.machine_id,
          unit_id: testSelected.unit_id,
          abbreviation: testSelected.abbreviation,
          name: testSelected.name,
          has_sub_tests: testSelected.has_sub_tests,
          input_type: testSelected.input_type,
          separate_from_test_type: testSelected.separate_from_test_type,
          separate_from_remark: testSelected.separate_from_remark,
          remark: testSelected.remark,
          display_ref_alert: testSelected.display_ref_alert,
          display_abbreviation: testSelected.display_abbreviation,
          specimen_type: testSelected.specimen_type,
        };
      }

      if (
        this.testInput.input_type === "dropdown" ||
        this.testInput.input_type === "radio" ||
        this.testInput.input_type === "checkbox"
      ) {
        this.options = testSelected.test_option;
      }

      // this.itemSelected= this.items.find((item) => {
      //   return item.id === testId;
      // }) || null;
      //
      // let testGroupMachineIndex = this.inputFields.findIndex(field => {
      //   return    field.key === 'machine_id'
      // })
      //
      // if (testGroupMachineIndex >= 0) {
      //   this.inputFields[testGroupMachineIndex].resources = await this.getMachine()
      // }
      //
      // let testGroupTestTypeIndex = this.inputFields.findIndex(field => {
      //   return    field.key === 'test_type_id'
      // })
      //
      // if (testGroupTestTypeIndex >= 0) {
      //   this.inputFields[testGroupTestTypeIndex].resources = await this.getTestType()
      // }

      this.$refs["inputModal"].show();
    },
    openDeleteModal(testId) {
      this.deleteTestIdSelected = testId;
      this.$refs["confirmDelete"].show();
    },
    async submit() {
      // let payload = {}
      // let malformedCheck = false
      if (
        !this.testInput.test_type_id ||
        !this.testInput.price ||
        !this.testInput.name ||
        !this.testInput.input_type
      ) {
        return;
      }
      if (
        this.testInput.input_type === "dropdown" ||
        this.testInput.input_type === "radio" ||
        this.testInput.input_type === "checkbox"
      ) {
        if (this.options.length === 0) {
          return;
        }
        this.testInput.options = this.options;
      }

      for (const [key, value] of Object.entries(this.testInput)) {
        if (value === null) {
          delete this.testInput[key];
        }
      }

      if (this.testInput.price) {
        this.testInput.price = +this.testInput.price;
      }

      if (this.testInput.options) {
        for (const option of this.testInput.options) {
          for (const [optionKey, optionValue] of Object.entries(option)) {
            if (optionValue === null) {
              delete option[optionKey];
            }
          }
        }
      }

      // test_type_id: this.testTypeId,
      //   for_specie_id: null,
      //   is_specify_detail: null,
      //   price: null,
      //   machine_id: null,
      //   unit_id: null,
      //   abbreviation: null,
      //   name: null,
      //   has_sub_tests: false,
      //   input_type: null,
      //   separate_from_test_type: null,
      //   separate_from_remark: null,
      //   remark: null,
      //   display_ref_alert: null,
      //   display_abbreviation: false,

      // if (malformedCheck) {
      //   return ;
      // }

      // if (this.itemSelected) {
      //   var res = await this.updateTest({
      //     payload,
      //     id: this.itemSelected.id
      //   });
      // } else {
      //   var res = await this.createTest(payload);
      // }
      let res;
      if (this.testInput.id) {
        try {
          res = await this.updateTest(this.testInput);
        } catch (err) {
          this.$swal.fire(err);
        }
      } else {
        try {
          res = await this.createTest(this.testInput);
        } catch (err) {
          this.$swal.fire(err);
        }
      }

      if (res) {
        this.testInput = {
          test_type_id: this.testTypeId,
          for_specie_id: null,
          is_specify_detail: null,
          price: null,
          machine_id: null,
          unit_id: null,
          abbreviation: null,
          name: null,
          has_sub_tests: false,
          input_type: null,
          separate_from_test_type: null,
          separate_from_remark: null,
          remark: null,
          display_ref_alert: null,
          display_abbreviation: false,
          specimen_type: [],
        };
      }

      Swal.fire("สำเร็จ", "สร้างรายการตรวจเสร็จสิ้น", "success");
      this.$nextTick(async () => {
        try {
          let testUpdated = await this.getTestByTestTypeId(this.testTypeId);

          this.$emit("update:tests", testUpdated);
        } catch (e) {
          this.$store.state.isLoading = false;
        }
        this.$store.state.isLoading = false;
      });
      this.$refs["inputModal"].hide();
      this.itemSelected = null;
    },
    clearInputField() {
      if (this.itemSelected) {
        this.inputFields.forEach((el) => {
          el.value = this.itemSelected[el.key];
        });
      } else {
        this.inputFields.forEach((el) => {
          el.value = "";
        });
      }
      this.modalTitle = this.itemSelected ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล";
    },
    async delTest() {
      let res = await this.deleteTest(this.deleteTestIdSelected);
      this.deleteTestIdSelected = null;
      this.items = await this.getTests();
      this.$refs["confirmDelete"].hide();
    },
    async changePositionHandler(id, type) {
      this.$store.state.isLoading = true;
      let prepareSequence = [];
      try {
        prepareSequence = this.tests.map((item) => ({
          id: item.id,
          sequence: item.sequence,
        }));
        let itemChange = prepareSequence.find((item) => item.id === id);
        let newIndex =
          type === "up"
            ? itemChange.sequence === 1
              ? 1
              : itemChange.sequence - 1
            : itemChange.sequence === _.maxBy(prepareSequence, "sequence")
            ? _.maxBy(prepareSequence, "sequence")
            : itemChange.sequence + 1;
        prepareSequence.forEach((item) => {
          if (item.sequence === newIndex) {
            item.sequence =
              type === "up" ? item.sequence + 1 : item.sequence - 1;
          }
          if (item.id === id) {
            item.sequence = newIndex;
          }
        });
      } catch (e) {
        this.$store.state.isLoading = false;
      }

      try {
        await this.updateSequenceTest(prepareSequence);
      } catch (e) {}

      this.$nextTick(async () => {
        try {
          let testUpdated = await this.getTestByTestTypeId(this.testTypeId);

          this.$emit("update:tests", testUpdated);
        } catch (e) {
          this.$store.state.isLoading = false;
        }
        this.$store.state.isLoading = false;
      });
    },
    checkMinMax(item, array, needle, type) {
      if (type === "min") {
        return item === _.minBy(array, needle)[needle];
      } else if (type === "max") {
        return item === _.maxBy(array, needle)[needle];
      }
    },
    resetTestInput() {
      this.testInput = {
        test_type_id: this.testTypeId,
        for_specie_id: null,
        is_specify_detail: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        name: null,
        has_sub_tests: false,
        input_type: null,
        separate_from_test_type: null,
        separate_from_remark: null,
        remark: null,
        display_ref_alert: null,
        specimen_type: [],
      };
    },
    openTestTypeHandler() {},
    subBackHandler() {
      this.isSubTestView = false;
      this.testSelected = null;
      this.subTests = [];
      this.testSelectedName = "";
    },
    async openSubTestHandler(id) {
      try {
        this.subTests = await this.getSubTestListByTestId(id);
      } catch (err) {
        console.error(err);
        return;
      }
      this.isSubTestView = true;
      this.testSelected = id;
      this.testSelectedName = this.tests.find((item) => item.id === id).name;
    },
    openSpecimenTypeHandler(id) {},
  },
  async mounted() {
    // this.items = await this.getTests()
  },
};
</script>

<style lang="scss" scoped>
.icon {
  cursor: pointer;
  &.warning {
    color: #ffc107;
  }
  &.danger {
    color: #dc3545;
  }
  &.disable {
    opacity: 0.4;
    cursor: default;
  }
}
</style>
<style scoped>
@media (min-width: 992px) .modal-lg {
  max-width: auto !important;
}

@media (min-width: 576px) .modal-dialog {
  max-width: auto !important;
}
</style>
